import { Notification } from "@rio-cloud/rio-uikit";

import { navigateTo } from "@/routes/navigationHelper";
import Logger from "@/utils/logger";

import { getIntl } from "../lang/lang";
import { TKnownError } from "./types";

const LOGGER_TAG = "Error_Handler";


/**
 * Handles a known application error by applying its configured side effects.
 *
 * - Skips processing if the error has been delegated to the client
 * - Displays a user-facing notification unless the error is marked as silent
 * - Redirects the user if a `redirectTo` route is provided
 *
 * @param error - The known error to handle
 */
export function handleKnownError(error: TKnownError) {
  const intl = getIntl();

  Logger.trace(LOGGER_TAG, "Caught error will be handled", error);
  
  const { delegateToClient, silent, redirectTo, message } = error;

  if (delegateToClient) return;

  if (!silent) {
    Notification.error(intl.formatMessage({ id: message }))
  }

  if (redirectTo) {
    navigateTo(redirectTo);
  }
};
